import Experience from "./Experience.js"
import three from "three"
import gsap from "gsap"
import TweenMax from "gsap"

export default class Animation {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug
        this.camera = this.experience.camera
        this.experience.current = "0"
        this.canvas = this.experience.canvas
        this.setTransitionInit()
    }

    setTransitionInit() {
        function closePopup() {
            gsap.to(".popup", {
                opacity: 0,
                display: "none",
                zIndex: -1
            })
        }
        closePopupInfo.addEventListener("click", () => {
            closePopup()
        })
        closePopupContact.addEventListener("click", () => {
            closePopup()
        })
        openPopupContact.addEventListener("click", () => {
            gsap.to(popupInfo, {
                opacity: 1,
                display: "flex",
                zIndex: 50
            })
        })
        openPopupInfo.addEventListener("click", () => {
            gsap.to(popupContact, {
                opacity: 1,
                display: "flex",
                zIndex: 50
            })
        })

        function crossclose() {
            gsap.to(".cross", {
                rotate: 0 + "deg"
            })
        }

        let navclose = false

        function navClose() {
            if (navclose) {
                gsap.to(".navbar", {
                    translateX: 0 + "%",
                    ease: "back.out(1.7)",
                    duration: 0.7
                })
                gsap.to(".clsNavSign", {
                    rotate: 0
                })
                navclose = false
            } else {
                gsap.to(".navbar", {
                    transform: "translateX(calc(-100% - 1em))",
                    ease: "back.out(1.7)",
                    duration: 0.7
                })
                gsap.to(".clsNavSign", {
                    rotate: 180
                })
                navclose = true
            }
        }
        clsNav.addEventListener("click", () => {
            navClose()
        })
        let legclose = false
        clsLgd.addEventListener("click", () => {
            if (legclose) {
                gsap.to(".legende", {
                    translateX: 100 + "%",
                    ease: "back.out(1.7)",
                    duration: 0.7
                })
                gsap.to(".clsLegSign", {
                    rotate: 180
                })
                legclose = false
            } else {
                gsap.to(".legende", {
                    translateX: 0 + "%",
                    ease: "back.out(1.7)",
                    duration: 0.7
                })
                gsap.to(".clsLegSign", {
                    rotate: 0
                })
                legclose = true
            }
        })

        this.canvas.addEventListener("mousedown", () => {
            gsap.to(navbar, {
                opacity: 0.3
            })
            this.canvas.style.cursor = "grabbing"
        })
        this.canvas.addEventListener("mouseup", () => {
            gsap.to(navbar, {
                opacity: 1
            })
            this.canvas.style.cursor = "grab"
        })
    }
    update() {}
}